// libraries
import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import firebase from "../../firebase/firebase";
import { useToasts } from "react-toast-notifications";

// icons
import { FaTrash } from "react-icons/fa";
import { GoCheck } from "react-icons/go";

// components
import Loading from "../Loading";

const recipesDocument = firebase.firestore().collection("recipes");

const AdminStatusItem = ({ data, status }) => {
  // use state
  const [loading, setLoading] = useState(false);
  const [switchOn, setSwitchOn] = useState(false);

  // use history
  const history = useHistory();

  // use toast
  const { addToast } = useToasts();

  const { uuid: id } = data;

  useEffect(() => {
    recipesDocument
      .doc(id)
      .get()
      .then((snap) => {
        setSwitchOn(snap.data().recommended);
      });
  }, [id]);

  const handleSwitch = (e) => {
    if (e.stopPropagation) e.stopPropagation();
    setLoading(true);
    setSwitchOn(!switchOn);
    recipesDocument
      .doc(data.uuid)
      .update({
        recommended: switchOn ? false : true,
      })
      .then(() => {
        addToast("Recipe recommended status changed!", {
          appearance: "success",
        });
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        addToast("An error has occurred! Please try again", {
          appearance: "error",
        });
      });
  };

  // handle approve click
  const approveItem = (e, id) => {
    if (e.stopPropagation) e.stopPropagation();
    setLoading(true);
    recipesDocument
      .doc(id)
      .update({
        status: "approved",
      })
      .then(() => {
        addToast("Recipe status changed successfully!", {
          appearance: "success",
        });
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        addToast("An error has occurred! Please try again", {
          appearance: "error",
        });
      });
  };
  // handle reject click
  const rejectItem = (e, id) => {
    if (e.stopPropagation) e.stopPropagation();
    setLoading(true);
    recipesDocument
      .doc(id)
      .update({
        status: "rejected",
      })
      .then(() => {
        addToast("Recipe status changed successfully!", {
          appearance: "success",
        });
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        addToast("An error has occurred! Please try again", {
          appearance: "error",
        });
      });
  };

  return (
    <div
      onClick={() => history.push(`/admin/${data.category}/${data.uuid}`)}
      className='admin-status-item'
    >
      {loading && <Loading fixed={true} />}
      <div className='d-flex align-items-center admin-status-item-img-container'>
        <img src={data.image} alt={data.recipe} />
        <p>{data.recipe}</p>
      </div>
      <div
        className='d-flex align-items-center justify-content-center'
        style={{ flex: "1" }}
      >
        <label className='m-0 mr-2'>Recommended</label>
        <div onClick={(e) => handleSwitch(e)} className='ToggleSwitch'>
          <div className={switchOn ? "knob switch-active" : "knob"} />
        </div>
      </div>
      <div>
        {status === "approved" ? (
          <div
            className='trash-wrapper'
            onClick={(e) => rejectItem(e, data.uuid)}
          >
            <FaTrash className='trash' />
          </div>
        ) : status === "pending" ? (
          <div className='row align-items-center'>
            <div
              className='trash-wrapper'
              onClick={(e) => approveItem(e, data.uuid)}
            >
              <GoCheck className='check' size={20} />
            </div>
            <div
              className='trash-wrapper'
              onClick={(e) => rejectItem(e, data.uuid)}
            >
              <FaTrash className='trash' />
            </div>
          </div>
        ) : (
          <div
            className='trash-wrapper'
            onClick={(e) => approveItem(e, data.uuid)}
          >
            <GoCheck className='check' size={20} />
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminStatusItem;
